import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { MdEdit } from "react-icons/md";
import TableColumn from "../../../components/TableColumn/TableColumn";

const PastAdvertising = () => {
  const navigate = useNavigate();
  const sorts = ["Client", "Status"];
  const headings = [
    "Time",
    "Client",
    "Location",
    "Website",
    "About",
    "Status",
    "",
  ];
  const [ads, setAds] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(
      Number(localStorage.getItem("ListCurrentPageAdvertising")) || 1
  );
  const records = 10;

  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [loading, setLoading] = useState(false);

  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp);
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

  const fetchData = async (page, term) => {
    setLoading(true);
    try {
      const response = await api.get("/ads", {
        params: {
          page,
          records,
          name: term,
          sort_column: sortBy,
          sort: sortDirection,
        },
      });

      const now = new Date();

      const formattedEvents = response.data.data
          .filter((item) => {
            // Include ads that have ended (date_end in the past) OR were
            // soft-deleted — Katherine wants full history, nothing disappears.
            if (item.status === "deleted") return true;
            return item.date_end && new Date(item.date_end) < now;
          })
          .map((item) => ({
            Time:
                item.date_start && item.date_end
                    ? `${formatDate(item.date_start)} - ${formatDate(item.date_end)}`
                    : "N/A",
            Client: item.business_name || item.venue_name || (
                <span style={{ color: "red" }}>Client not informed</span>
            ),
            Location: item.location,
            Website: item.website,
            About: item.about,
            Status: item.status,
            _id: item._id,
          }));

      setTotalPages(Math.ceil(response.data.total));
      setAds(formattedEvents);
    } catch (error) {
      console.log(`Ads get request didn't work. error: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage, searchTerm);
  }, [sortBy, sortDirection, currentPage, searchTerm]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    localStorage.setItem("ListCurrentPageAdvertising", page);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setCurrentPage(1);
  };

  const sortColumnsMapping = {
    Client: "business_name",
    Status: "status",
  };

  const handleSort = (columnName) => {
    const backendColumnName = sortColumnsMapping[columnName];
    if (sortBy === backendColumnName) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(backendColumnName);
      setSortDirection("asc");
    }
  };

  const actions = [
    {
      label: <MdEdit size={30} color="#4F30EA" />,
      onClick: (rowData) => {
        navigate(`/ad-management/edit/${rowData._id}`);
      },
    },
  ];

  const fetchAllData = async () => {
    try {
      const response = await api.get("/ads", { params: { records: 1000 } });
      return response.data.data.map((item) => ({
        Client: item?.business_name,
        Location: item?.event_name,
        Website: item?.website,
        About: item?.about,
        Status: item?.status,
        _id: item._id,
      }));
    } catch (error) {
      console.log(`Error fetching all data: ${error}`);
      return [];
    }
  };

  return (
      <section className="past-ads position-relative">
        <TableColumn
            hasHeader
            columns={headings}
            data={ads}
            sortableColumns={sorts}
            hasExport
            hasSearch
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            records={records}
            actions={actions}
            inputSearchProps={{ value: searchTerm, onChange: handleChange }}
            fetchAllData={fetchAllData}
            onSort={handleSort}
            hasModifyHeader
            loading={loading}
        />
      </section>
  );
};

export default PastAdvertising;
